import type { Ref } from 'react';
import { useLayoutEffect } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import { PillCluster } from './PillCluster';
import { TopBar, type TopBarProps } from './TopBar';
import type { HeaderPillSpec } from './HeaderPill';
import { cx } from '../lib/cx';
import { useModalFrame } from '../lib/modalContext';

type ModalHeadLeft =
  | { title?: string; left?: never }
  | { title?: never; left?: HeaderPillSpec };

export type ModalHeadProps = Omit<HTMLAttributes<HTMLElement>, 'title' | 'children'> &
  ModalHeadLeft & {
    center?: ReactNode;
    titleIcon?: string;
    modalSize?: 'compact' | 'form' | 'document';
    modalLabel?: string;
    leftProps?: TopBarProps['leftProps'];
    actions?: ReactNode;
    onClose: () => void;
    closeLabel: string;
    closeDisabled?: boolean;
    closeTestId?: string;
    onBack?: () => void;
    backLabel?: string;
    };

export function ModalHead(
  { ref, title,
    center,
    titleIcon = 'i-info',
    modalSize,
    modalLabel,
    left,
    actions,
    onClose,
    closeLabel,
    closeDisabled = false,
    closeTestId,
    onBack,
    backLabel = "Zurück",
    className,
    ...rest
  }: ModalHeadProps & { ref?: Ref<HTMLElement> },
) {
  const frame = useModalFrame();
  useLayoutEffect(() => frame?.registerClose(onClose, closeDisabled, modalSize, modalLabel ?? (typeof title === 'string' ? title : undefined)), [frame, onClose, closeDisabled, modalSize, modalLabel, title]);
  const start = left ?? (title != null ? { type: 'title' as const, label: title, icon: titleIcon } : undefined);
  return (
    <TopBar
      ref={ref}
      className={cx('modal-head', className)}
      center={center}
      left={start}
      close={{ label: closeLabel, testId: closeTestId, disabled: closeDisabled }}
      back={onBack ? { label: backLabel, onClick: onBack, disabled: closeDisabled } : undefined}
      right={
        <PillCluster>
          {actions}

        </PillCluster>
      }
      {...rest}
    />
  );
}
